import { render, staticRenderFns } from "./OrganizationPeerGroupGoals.vue?vue&type=template&id=9dc444d4&scoped=true&"
import script from "./OrganizationPeerGroupGoals.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupGoals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc444d4",
  null
  
)

export default component.exports